export const translations = {
  en: {
    // Category names
    "Admin Tasks": "Admin Tasks",
    "Ground Crew Tasks": "Ground Crew Tasks",
    "Mineral Labs Tasks": "Mineral Labs Tasks",
    "Operations Supervisor Tasks": "Operations Supervisor Tasks",
    "Comptoir Trade Manager Tasks": "Comptoir Trade Manager Tasks",
    "Comptoir Director Tasks": "Comptoir Director Tasks",
    "Operations Manager Tasks": "Operations Manager Tasks",
    "Finance Tasks": "Finance Tasks",
    "Mining Board Regulator Agent Tasks": "Mining Board Regulator Agent Tasks",
    "Transporter Tasks": "Transporter Tasks",
    "Completed":" Completed",
    
    // General UI elements
    "Days More": "Days More",
    "Time Tracking": "Time Tracking",
    "Export": "Export",
    "Dashboard": "Dashboard",
    "Exports": "Exports",
    "Loading...": "Loading...",
    "No data available": "No data available",
    "Time Tracking | Minexx": "Time Tracking | Minexx",
    
    // Admin Tasks
    "Supplier KYC Checks": "Supplier KYC Checks",
    "Mine sheets +Tag list provided by Supplier": "Mine sheets + Tag list provided by Supplier",
    "Price convened, a purchase sheet raised + supplier is paid": "Price convened, purchase sheet raised + supplier paid",
    "Holding Certificate Generated": "Holding Certificate Generated",
    "Admin calls on the transporter for a Truck to Transport Minerals": "Admin calls transporter for truck to transport minerals",
    "All tags list loaded into Tag Management System": "All tags loaded into Tag Management System",
    "Import Confirmation Certification provided by Mining Board Regulator": "Import confirmation certification provided by Mining Board Regulator",
    "Tax Payment to the Revenue Authority": "Tax payment to Revenue Authority",
    "RRA DOCUMENTS(ORIGIN CERTIFICATE,DECLARATION,T1.RELEASE EXIT)": "RRA documents (origin certificate, declaration, T1 release exit)",
    "BL is generated by the shipping line": "BL generated by shipping line",
    
    // Ground Crew Tasks
    "Weighing Minerals against Receivables": "Weighing minerals against receivables",
    "Crushing and Processing": "Crushing and processing",
    "Minerals re-stocking into Big Bags +Lot Assignment": "Minerals re-stocking into big bags + lot assignment",
    "Minerals Weighing after processing": "Minerals weighing after processing",
    "Several Lots are blended to reach 25 tons (1 container)": "Several lots blended to reach 25 tons (1 container)",
    "Blended Lots are put in Drums (each varies from 700kg to 950kg)": "Blended lots put in drums (700kg-950kg each)",
    
    // Mineral Labs Tasks
    "Mineral sample take": "Mineral sample take",
    "Mineral Labs provide an analysis report for chemical analysis": "Mineral labs provide analysis report for chemical analysis",
    "Sample- take to Labs for % detailed analysis": "Sample take to labs for detailed analysis",
    "Lab shares the certificate of Assay and the packing list": "Lab shares assay certificate and packing list",
    "Drums are tag-sealed and Numbered": "Drums are tag-sealed and numbered",
    
    // Operations Supervisor Tasks
    "Lot Data capturing into Minexx Tool (Processing)": "Lot data capturing into Minexx tool (processing)",
    "Lot test result and pricing data capturing into Minexx Tool": "Lot test result and pricing data capturing into Minexx tool",
    "Blending data capturing into Minexx Tool": "Blending data capturing into Minexx tool",
    "Export Data capturing +shipment files (COO, ICGLR etc..)": "Export data capturing + shipment files (COO, ICGLR etc.)",
    
    // Comptoir Trade Manager Tasks
    "Comptoir Representative negotiates the price with the supplier": "Comptoir representative negotiates price with supplier",
    
    // Comptoir Director Tasks
    "Price Verification and Validation": "Price verification and validation",
    
    // Operations Manager Tasks
    "Shipment tracking provided by Transporter": "Shipment tracking provided by transporter",
    
    // Finance Tasks
    "Price convened, a purchase sheet is raised and the supplier is paid.": "Price convened, purchase sheet raised and supplier paid",
    "Upon Goods receipt Buyer pays Minexx": "Upon goods receipt buyer pays Minexx",
    
    // Mining Board Regulator Agent Tasks
    "ITSCi Processing Logbook Data signed + stamped by MBRA": "ITSCi processing logbook data signed + stamped by MBRA",
    "Export Sheet signed + stamped by MBRA": "Export sheet signed + stamped by MBRA",
    "C 2 Form provided by the MBRA": "C2 form provided by MBRA",
    
    // Transporter Tasks
    "Blended Lots put in the truck and moved to Port with all documents": "Blended lots put in truck and moved to port with all documents",
    "Drums stationed at Transporter Station (CFS)": "Drums stationed at transporter station (CFS)",
    "Drums moved to shipping line containers": "Drums moved to shipping line containers",
    "Containers/Drums inspected by Government Authority and Cleared": "Containers/drums inspected by government authority and cleared",
    "Containers moved to shipping line + moved to Final Destination": "Containers moved to shipping line + moved to final destination"
  },
  
  fr: {
    // Category names
    "Admin Tasks": "Tâches Administratives",
    "Ground Crew Tasks": "Tâches de l'Équipe au Sol",
    "Mineral Labs Tasks": "Tâches des Laboratoires Minéraux",
    "Operations Supervisor Tasks": "Tâches du Superviseur des Opérations",
    "Comptoir Trade Manager Tasks": "Tâches du Responsable Commercial du Comptoir",
    "Comptoir Director Tasks": "Tâches du Directeur du Comptoir",
    "Operations Manager Tasks": "Tâches du Responsable des Opérations",
    "Finance Tasks": "Tâches Financières",
    "Mining Board Regulator Agent Tasks": "Tâches de l'Agent Régulateur du Conseil Minier",
    "Transporter Tasks": "Tâches du Transporteur",
    "Completed": "Terminé",
    
    // General UI elements
    "Days More": "Jours Restants",
    "Time Tracking": "Suivi du Temps",
    "Export": "Exporter",
    "Dashboard": "Tableau de Bord",
    "Exports": "Exportations",
    "Loading...": "Chargement...",
    "No data available": "Aucune donnée disponible",
    "Time Tracking | Minexx": "Suivi du Temps | Minexx",
    
    // Admin Tasks
    "Supplier KYC Checks": "Vérifications KYC Fournisseur",
    "Mine sheets +Tag list provided by Supplier": "Feuilles de mine + liste des tags fournie par le fournisseur",
    "Price convened, a purchase sheet raised + supplier is paid": "Prix convenu, feuille d'achat créée + fournisseur payé",
    "Holding Certificate Generated": "Certificat de détention généré",
    "Admin calls on the transporter for a Truck to Transport Minerals": "L'admin appelle le transporteur pour un camion pour transporter les minéraux",
    "All tags list loaded into Tag Management System": "Liste de tous les tags chargée dans le système de gestion des tags",
    "Import Confirmation Certification provided by Mining Board Regulator": "Certification de confirmation d'importation fournie par le régulateur du conseil minier",
    "Tax Payment to the Revenue Authority": "Paiement de taxe à l'autorité fiscale",
    "RRA DOCUMENTS(ORIGIN CERTIFICATE,DECLARATION,T1.RELEASE EXIT)": "Documents RRA (certificat d'origine, déclaration, sortie T1)",
    "BL is generated by the shipping line": "Le BL est généré par la ligne maritime",
    
    // Ground Crew Tasks
    "Weighing Minerals against Receivables": "Pesée des minéraux contre les créances",
    "Crushing and Processing": "Broyage et traitement",
    "Minerals re-stocking into Big Bags +Lot Assignment": "Réapprovisionnement des minéraux dans de gros sacs + attribution de lots",
    "Minerals Weighing after processing": "Pesée des minéraux après traitement",
    "Several Lots are blended to reach 25 tons (1 container)": "Plusieurs lots sont mélangés pour atteindre 25 tonnes (1 conteneur)",
    "Blended Lots are put in Drums (each varies from 700kg to 950kg)": "Les lots mélangés sont mis en fûts (chacun varie de 700kg à 950kg)",
    
    // Mineral Labs Tasks
    "Mineral sample take": "Prise d'échantillon minéral",
    "Mineral Labs provide an analysis report for chemical analysis": "Les laboratoires minéraux fournissent un rapport d'analyse pour l'analyse chimique",
    "Sample- take to Labs for % detailed analysis": "Échantillon - emmené aux laboratoires pour une analyse détaillée en %",
    "Lab shares the certificate of Assay and the packing list": "Le laboratoire partage le certificat d'essai et la liste de colisage",
    "Drums are tag-sealed and Numbered": "Les fûts sont scellés par étiquette et numérotés",
    
    // Operations Supervisor Tasks
    "Lot Data capturing into Minexx Tool (Processing)": "Capture des données de lot dans l'outil Minexx (traitement)",
    "Lot test result and pricing data capturing into Minexx Tool": "Capture des résultats de test de lot et des données de prix dans l'outil Minexx",
    "Blending data capturing into Minexx Tool": "Capture des données de mélange dans l'outil Minexx",
    "Export Data capturing +shipment files (COO, ICGLR etc..)": "Capture des données d'exportation + fichiers d'expédition (COO, ICGLR etc.)",
    
    // Comptoir Trade Manager Tasks
    "Comptoir Representative negotiates the price with the supplier": "Le représentant du comptoir négocie le prix avec le fournisseur",
    
    // Comptoir Director Tasks
    "Price Verification and Validation": "Vérification et validation des prix",
    
    // Operations Manager Tasks
    "Shipment tracking provided by Transporter": "Suivi d'expédition fourni par le transporteur",
    
    // Finance Tasks
    "Price convened, a purchase sheet is raised and the supplier is paid.": "Prix convenu, une feuille d'achat est créée et le fournisseur est payé",
    "Upon Goods receipt Buyer pays Minexx": "Dès réception des marchandises, l'acheteur paie Minexx",
    
    // Mining Board Regulator Agent Tasks
    "ITSCi Processing Logbook Data signed + stamped by MBRA": "Données du carnet de bord de traitement ITSCi signées + tamponnées par MBRA",
    "Export Sheet signed + stamped by MBRA": "Feuille d'exportation signée + tamponnée par MBRA",
    "C 2 Form provided by the MBRA": "Formulaire C2 fourni par le MBRA",
    
    // Transporter Tasks
    "Blended Lots put in the truck and moved to Port with all documents": "Lots mélangés mis dans le camion et déplacés vers le port avec tous les documents",
    "Drums stationed at Transporter Station (CFS)": "Fûts stationnés à la station de transport (CFS)",
    "Drums moved to shipping line containers": "Fûts déplacés vers les conteneurs de la ligne maritime",
    "Containers/Drums inspected by Government Authority and Cleared": "Conteneurs/fûts inspectés par l'autorité gouvernementale et dédouanés",
    "Containers moved to shipping line + moved to Final Destination": "Conteneurs déplacés vers la ligne maritime + déplacés vers la destination finale"
  }

};


//notes for endpoint in the reporting section 
// 1./report/timestamp
// 2./report/trendgraph/${supplierId}